// Api for email subscription
export default function dripEnergieApiUrl() {
    return '/ajax/drip/signup-email';
}

export const mijnKeuzeApiURL = () => {
    if (import.meta.env.VITE_MIJNKEUZE_API_URL) {
        return import.meta.env.VITE_MIJNKEUZE_API_URL;
    }
    else if (import.meta.env.DEV) {
        return 'https://api-mijnkeuze.keuze.dev';
    }
    return 'https://api-mijnkeuze.keuze.nl';
};
